<template>
	<div class="page_content module_course" aria-label="Assessment learn Page Content">

		<course-header :course-id="course.uuid"  :entityUuid="entityUuid" class="header_assessment_learn"></course-header>

		<div class="row page-content" :class="isTocOpen ? 'toc_activated' : ''">
			<div class="col-12 assessment-learn can_full_screen full_screen">

				<div class="header">
					<span v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></span>
					<span class="heading ace_sec_hd">{{ancestor}} > {{parent}} > {{entity.title}}</span>
          			<div class="btn_container">
						<b-button @click="done(course.uuid, entity.objectType, entity.uuid)" class="btn button-primary next"> Done </b-button>
						<full-screen-method></full-screen-method>
          			</div>

				</div>

				<div v-if="loadLaunchAssessmentWidget" class="assessment-container">
					<template>
                        <div id="learnosity_assess"></div>
                    </template>
            	</div>

			</div>
		</div>

	</div>
</template>

<script>
/* global LearnosityItems:true */
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import TOC from './TOC'
import fullScreenMethod from '../../common/components/fullScreenMethod'

export default {
  name: 'assessment-learn-instructor',
  props: ['uuid', 'entityType', 'entityUuid', 'sessionId'],
  components: {
    CourseHeader,
    CourseNav,
    TOC,
    fullScreenMethod
  },
  data: () => {
    return {
      page: 1,
      parent: null,
      ancestor: null,
      itemsApp: {},
      loadLaunchAssessmentWidget: false
    }
  },

  mounted () {
    this.loadCourse()
  },

  beforeDestroy () {
    if (typeof this.itemsApp.reset === 'function') {
      this.itemsApp.reset()
    }
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail',
      'launchAssessment'
    ]),

    loadCourse () {
      this.loadCourseDetail(this.uuid)
      const entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.loadEntityDetail(entityDetailInfo).then((res) => {
        if (res && res.type === 'ASSESSMENT') {
          this.loadLaunchAssessmentWidget = true
          this.initLaunchAssessment()
        }
        var i = 0
        var j = 0
        var parentAncestorId = null
        for (i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.entity.ancestor) {
            if (this.linearTopics[j].title.indexOf(':') > -1) {
              this.parent = this.linearTopics[i].title.split(':')[0]
            } else {
              this.parent = this.linearTopics[i].title
            }
            parentAncestorId = this.linearTopics[i].ancestor
            break
          }
        }

        if (parentAncestorId != null) {
          for (j = 0; j < this.linearTopics.length; j++) {
            if (this.linearTopics[j].uuid === parentAncestorId) {
              if (this.linearTopics[j].title.indexOf(':') > -1) {
                this.ancestor = this.linearTopics[j].title.split(':')[0]
              } else {
                this.ancestor = this.linearTopics[j].title
              }
              break
            }
          }
        }
      })
    },

    initLaunchAssessment () {
      this.launchAssessment({uuid: this.entityUuid, courseId: this.uuid, sessionId: this.sessionId}).then(res => {
        if (res) {
          const signedRequest = JSON.parse(res.signedRequest)
          var self = this
          self.itemsApp = LearnosityItems.init(signedRequest, {
            'readyListener': function () {
              self.bindReadyListener()
            },
            'errorListener': function (event) {
              console.log('error: ', event)
            }
          })
        }
      })
    },

    bindReadyListener () {
      this.getMinAndMaxScoreForActiveQuestion()
      var assessApp = this.itemsApp.assessApp()
      assessApp.on('item:load', () => {
        this.getMinAndMaxScoreForActiveQuestion()
      })
    },

    getMinAndMaxScoreForActiveQuestion () {
      $.each(this.itemsApp.getItems(), (index, item) => {
        if (item.active) {
          let maxScore = 0
          $.each(item.questions, (i, question) => {
            if (question.metadata.valid_response_count === 0) {
              maxScore += (question.validation && question.validation.max_score) ? question.validation.max_score : 0
            }
          })
          $('.lrn-min-max-score').remove()
          if (maxScore > 0) {
            $('.lrn-top-left-region').append('<div class="lrn-min-max-score">Min Score: 0 and Max Score: ' + maxScore + '</div>')
          }
        }
      })
    },

    done (uuid, entityType, entityUuid) {
      this.$router.push({ name: 'entityDetailInstructor', params: { uuid: uuid, entityType: entityType, entityUuid: entityUuid } })
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'entity': state => state.course.entity,
			'isTocOpen': state => state.course.isTocOpen,
      'linearTopics': state => state.course.linearTopics
    })
  },

  watch: {
    entityUuid (newId) {
      if (newId) {
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>

.header {
	background: #f7e5a8;
	margin-bottom: 30px;
	float: left;
    width: 100%;
	padding-left: 20px;
	height:62px;
}
.heading {
	float: left;
	font-size: 20px;
	margin-top: 17px;
	color: rgb(79, 79, 79);
	font-family: robotoSlab_Light;
	max-width: calc(100% - 138px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.btn_container {
	float: right;
    margin: 17px 18px 0 18px;
}
.container {
	width: 90%;
	max-width: 90%;
	margin-left: 5%;
	height: 98%;
}
.container iframe {
	width: 90% !important;
	margin-left: 5%;
	height: 95%;
}

.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description{
  padding-top:20px;
  padding-left:20px;
  padding-right:20px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.topic-list-item{
}

.entity-nav{
  background: #f8f9fa;
}
.pull-left{
  float:left;
}

.learning{
  margin-top: 30px;
}

.course-description {
	padding: 0px;
}
.assessment-container {
	padding-left: 5%;
	width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/app/course/components/AssessmentLearnInstructor.vue